import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { useApiTokenBinding } from './lib/api';
import { Login } from './pages/Login';
import { OrderCatalog } from './pages/OrderCatalog';
import { OrderReview } from './pages/OrderReview';
import { OrderConfirmation } from './pages/OrderConfirmation';
import { OrderHistory } from './pages/OrderHistory';
import { OrderDetail } from './pages/OrderDetail';
import { BackOrderAlerts } from './pages/BackOrderAlerts';
import { AdminDashboard } from './pages/AdminDashboard';
import { ProductSupplierMapping } from './pages/ProductSupplierMapping';
import { LocationsUsers } from './pages/LocationsUsers';
import { AdminOrderDetail } from './pages/AdminOrderDetail';
import { AdminOrderHistory } from './pages/AdminOrderHistory';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return <>{children}</>;
}

function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (user.role !== 'super_admin') return <Navigate to="/app" replace />;
  return <>{children}</>;
}

export function App() {
  useApiTokenBinding();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/login" replace />} />

      <Route
        path="/app"
        element={
          <RequireAuth>
            <OrderCatalog />
          </RequireAuth>
        }
      />
      <Route
        path="/app/review"
        element={
          <RequireAuth>
            <OrderReview />
          </RequireAuth>
        }
      />
      <Route
        path="/app/history"
        element={
          <RequireAuth>
            <OrderHistory />
          </RequireAuth>
        }
      />
      <Route
        path="/app/backorders"
        element={
          <RequireAuth>
            <BackOrderAlerts />
          </RequireAuth>
        }
      />
      <Route
        path="/app/orders/:id"
        element={
          <RequireAuth>
            <OrderDetail />
          </RequireAuth>
        }
      />
      <Route
        path="/app/orders/:id/confirmation"
        element={
          <RequireAuth>
            <OrderConfirmation />
          </RequireAuth>
        }
      />

      <Route
        path="/admin"
        element={
          <RequireAdmin>
            <AdminDashboard />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/products"
        element={
          <RequireAdmin>
            <ProductSupplierMapping />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/locations"
        element={
          <RequireAdmin>
            <LocationsUsers />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/history"
        element={
          <RequireAdmin>
            <AdminOrderHistory />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/orders/:id"
        element={
          <RequireAdmin>
            <AdminOrderDetail />
          </RequireAdmin>
        }
      />

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
